import "./App.css";

function App() {
  return (
    <div className="container">
      <div className="card">
        <h1>Conditions Générales de Vente – SENDO</h1>
        <p>
          Les présentes Conditions Générales de Vente (CGV) encadrent l’utilisation des services
          offerts par <strong>SENDO</strong>, une solution digitale opérée par SFE CAMEROUN SAS.
          Elles s’appliquent à tout utilisateur (client) ayant recours à SENDO pour effectuer ou
          recevoir des paiements, recharger son portefeuille ou utiliser les fonctionnalités
          financières offertes par la plateforme.
        </p>

        <h2>1. Définitions</h2>
        <ul>
          <li><strong>SENDO :</strong> plateforme digitale de services financiers fournie par SFE CAMEROUN SAS.</li>
          <li><strong>Utilisateur ou Client :</strong> personne physique ou morale qui utilise les services SENDO.</li>
          <li><strong>Compte SENDO :</strong> espace numérique personnel accessible via l’application mobile ou web.</li>
          <li><strong>Services :</strong> ensemble des fonctionnalités offertes par SENDO.</li>
        </ul>

        <h2>2. Objet et champ d’application</h2>
        <p>
          Les CGV régissent l’accès, l’utilisation et la gestion des services SENDO. En créant un
          compte et en utilisant la plateforme, le client accepte sans réserve les présentes
          conditions.
        </p>

        <h2>3. Services proposés</h2>
        <ul>
          <li>Recharge de portefeuille électronique (Mobile Money, carte bancaire, virement)</li>
          <li>Envoi et réception d’argent (local et international)</li>
          <li>Retrait d’argent via Mobile Money ou agents partenaires</li>
          <li>Partage de fonds entre amis (utilisateurs SENDO)</li>
          <li>Demande de fonds (fonction “Demander à un ami”)</li>
          <li>Participation à des groupes d’épargne (eTontine)</li>
          <li>Cartes prépayées SENDO (activation, recharge, opposition, renouvellement)</li>
        </ul>
        <p className="note">
          Les frais et modalités sont précisés dans la grille tarifaire accessible dans
          l’application.
        </p>

        <h2>4. Conditions d’accès au service</h2>
        <p>Pour s’inscrire :</p>
        <ul>
          <li>Être majeur</li>
          <li>Posséder un numéro de téléphone valide</li>
          <li>Effectuer la procédure KYC (pièce d’identité, selfie, justificatif)</li>
        </ul>

        <h2>5. Sécurité et responsabilité</h2>
        <p>
          L’utilisateur est responsable de la sécurité de son compte : code PIN, mot de passe,
          appareils utilisés. SENDO applique des mécanismes de protection et d’alerte en cas
          d’activité suspecte.
        </p>
        <p>Toute négligence de la part du client exonère SENDO de toute responsabilité directe.</p>

        <h2>6. Données personnelles et politique de confidentialité</h2>
        <p>
          SENDO collecte uniquement les données nécessaires à la gestion du compte client,
          conformément à sa Politique de Confidentialité.
        </p>
        <p>
          Les données sont stockées de manière sécurisée pendant la durée légale (5 ans) et ne sont
          jamais partagées sans autorisation sauf exigence réglementaire.
        </p>

        <h2>7. Réclamations et gestion des litiges</h2>
        <p>
          Tout utilisateur peut soumettre une réclamation par application, email ou téléphone. Les
          délais de traitement vont de 48h à 10 jours ouvrés selon la nature du litige. En cas de
          litige non résolu, le client peut saisir le régulateur local ou les autorités compétentes.
        </p>

        <h2>8. Suspension ou clôture de compte</h2>
        <p>
          SENDO peut suspendre ou clôturer un compte en cas de fraude, non-respect des CGV ou sur
          demande du client.
        </p>
        <p>
          Le solde est restitué, après vérification, sauf opposition judiciaire ou suspicion de
          blanchiment.
        </p>

        <h2>9. Tarification</h2>
        <p>
          Les frais sont affichés avant chaque opération dans l’application SENDO. Ils varient selon
          le canal utilisé (Mobile Money, carte, etc.). La grille tarifaire à jour est consultable
          dans l’application ou sur demande.
        </p>

        <h2>10. Durée, modifications et résiliation</h2>
        <p>
          Les CGV sont valides dès acceptation lors de la création du compte. Elles peuvent être
          modifiées avec préavis envoyé à l’utilisateur. L’utilisateur peut résilier à tout moment
          sous réserve de solde nul.
        </p>

        <h2>11. Juridiction applicable</h2>
        <p>
          Les présentes CGV sont régies par le droit en vigueur en République du Cameroun. En cas de
          désaccord persistant, les tribunaux compétents de Douala seront saisis.
        </p>
      </div>
    </div>
  );
}

export default App;
